export const dishesSteps = {
  first: 'first',
  second: 'second',
  third: 'third',
  fourth: 'fourth',
  fifth: 'fifth',
  // sixth: 'sixth',
};

export const categoriesStep = {
  first: 'first',
  second: 'second',
  third: 'third',
  fourth: 'fourth',
  // fifth: 'fifth',
};

export const optionSteps = {
  first: 'first',
  second: 'second',
  third: 'third',
  fourth: 'fourth',
};
